import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = authService.getToken();
  const user = authService.getUser();

  // If no token or user, redirect to login
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // If user is not admin, redirect to login
  if (!authService.isAdmin()) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
